enum LoginStep {
  EmailEntry = 'emailEntry',
  Registration = 'registration',
  Password = 'password',
  OtpVerification = 'otpVerification',
  ForgotPassword = 'forgotPassword',
  NewPassword = 'newPassword',
  PasswordResetSmsOtp = 'passwordResetSmsOtp',
}

type OtpPurpose = 'registration' | 'login' | 'passwordReset';
type OtpChannel = 'sms' | 'email';

interface IRegistrationDraft {
  firstName: string;
  lastName: string;
  preferredName: string;
}

interface ILoginFlowState {
  email: string;
  userId: string | null;
  otpPurpose: OtpPurpose;
  otpChannel?: OtpChannel;
  phoneLast4?: string;
  requiresSmsOtp?: boolean;
  // Carried across the email→SMS OTP transition for the final reset-password call
  pendingEmailCode?: string;
  pendingNewPassword?: string;
  // Preserved across back-nav so the user doesn't lose typed values when they
  // step away from RegistrationStep and come back. Password fields are
  // intentionally NOT preserved — re-entry is the expected pattern.
  registrationDraft?: IRegistrationDraft;
}

interface ILoginStepProps {
  flowState: ILoginFlowState;
  onBack?: () => void;
}

const RESEND_COUNTDOWN_SECONDS = 60;

export { LoginStep, RESEND_COUNTDOWN_SECONDS };
export type { ILoginFlowState, ILoginStepProps, IRegistrationDraft, OtpChannel, OtpPurpose };
